import dynaForms from '@elab/core/utils/dynaForms';

import { storeName } from './types';

const getPhoneVerificationForm = state => state[storeName] || {};
const getTimeout = state => getPhoneVerificationForm(state).timeout;
const getVerificationState = state => getPhoneVerificationForm(state).verificationState;
const getErrorMessage = state => getPhoneVerificationForm(state).errorMessage;
const getSessionId = state => getPhoneVerificationForm(state).sessionId;
const getIsRetryDisabled = state => getPhoneVerificationForm(state).isRetryDisabled;
const getCheckoutRegistrationMobile = state =>
    state['checkout-registration'] && state['checkout-registration'].data.mobileNumber.value;
const getUpdatePhonenumberAsPopup = state =>
    (state.updatePhoneNumber && state.updatePhoneNumber.useAsPopup) || false;
const getShowVerificationFieldFlag = state =>
    getPhoneVerificationForm(state).showPhoneVerificationField;
const getErrorCode = state => getPhoneVerificationForm(state).errorCode;

export default {
    ...dynaForms.getSelectors(storeName),
    getTimeout,
    getVerificationState,
    getErrorMessage,
    getSessionId,
    getIsRetryDisabled,
    getCheckoutRegistrationMobile,
    getUpdatePhonenumberAsPopup,
    getShowVerificationFieldFlag,
    getErrorCode,
};
